import { anyOf, arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

import type { AgentPreviewAsyncResult } from "./types";

const nullableString = anyOf(string, nullValidation);
const nullableArrayOfStrings = anyOf(arrayOf(string), nullValidation);

export const isAgentPreviewAsyncResult = objectOf<AgentPreviewAsyncResult>({
  status: number,
  result: maybe(nullableString),
  execution_time_ms: maybe(number),
  errors: maybe(nullableArrayOfStrings),
  error_code: maybe(string),
  tool_execution_logs: maybe(
    arrayOf(
      objectOf({
        name: string,
        arguments: maybe(nullableString),
        duration: maybe(number),
      })
    )
  ),
  execution_usage: maybe(
    objectOf({
      limits: objectOf({
        daily: maybe(number),
        max_daily: maybe(number),
        total: maybe(number),
      }),
      current_usage: objectOf({
        today: maybe(number),
        total: maybe(number),
      }),
      remaining: objectOf({
        today: maybe(number),
        total: maybe(number),
      }),
      exceeded_limit: boolean,
    })
  ),
  qa_results: maybe(
    arrayOf(
      objectOf({
        rule: string,
        status: string,
        reason: string,
        ruleset_name: maybe(string),
      })
    )
  ),
});
